import _curry3 from "./internal/_curry3.js";
var Identity = function (x) {
    return {
        value: x,
        map: function (f) {
            return Identity(f(x));
        }
    };
};
var over = _curry3(function over(lens, f, x) {
    return lens(function (y) {
        return Identity(f(y));
    })(x).value;
});
export default over;
